import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";

export const WrapperAllFiles = styled.div`
  width: 100%;
  padding: 10px;
  text-align: left;
  background-color: #fff;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  min-height: 80vh;
  position: relative;
  overflow-x: hidden;
`;

export const WrapperPathMapUl = styled.ul`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
`;

export const WrapperPathMapLi = styled.li`
  padding: 0;
  margin: 4px 0;
  color: #000;
  font-size: 13px;
  text-decoration: none;
  cursor: pointer;
  display: flex;
  align-items: center;
`;

export const WrapperPathMapSpan = styled.span`
  margin: 0 8px;
  color: #666;
`;

export const FileIcon = styled.img`
  width: 60px;
  height: 76px;
  margin: 14px auto;
`;

export const FileTitle = styled.div`
  width: 100%;
  font-size: 11px;
  text-align: center;
  color: #000000;
  margin-top: -15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const FileBox = styled.div`
  width: 100px;
  text-align: center;
  display: inline-block;
  margin: 10px;
`;

export const useStyles = makeStyles(() => ({
  breadcrumbRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "8px 0",
    flexWrap: "wrap",
    gap: "8px",
  },
  breadcrumbContainer: {
    flex: 1,
    minWidth: 0,
    maxWidth: "100%",
    overflowX: "auto",
    scrollbarWidth: "thin",
    "&::-webkit-scrollbar": {
      height: 6,
    },
    "&::-webkit-scrollbar-thumb": {
      backgroundColor: "rgba(0,0,0,0.2)",
      borderRadius: 3,
    },
  },
  breadcrumbCurrent: {
    fontWeight: 600,
    color: "#1a1a1a",
    cursor: "default",
  },
  breadcrumbLink: {
    color: "#0076FF",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  float_center: {
    margin: 0,
    textAlign: "left",
  },
  gridContainer: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    alignItems: "flex-start",
    alignContent: "flex-start",
    // Large empty area so drag-and-drop is easy (grid view, few/no files)
    minHeight: "min(560px, calc(100vh - 290px))",
  },
  closeOpt: {
    top: "11px",
    left: "11px",
    color: "white",
    width: "65px",
    cursor: "pointer",
    height: "31px",
    padding: "5px 0 0 8px",
    zIndex: "9999",
    position: "absolute",
    fontSize: "14px",
    backgroundColor: "#0076FF",
    borderRadius: "4px",
  },

  listHeader: {
    display: "grid",
    gridTemplateColumns: "5fr 1.2fr 0.8fr 1fr 1.6fr 50px",
    alignItems: "center",
    backgroundColor: "#0076FF",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "13px",
    height: "60px",
    padding: "0 8px",
    borderTopLeftRadius: "6px",
    borderTopRightRadius: "6px",
    position: "sticky",
    top: 0,
    zIndex: 2,
  },

  scrollListBody: {
    maxHeight: "calc(100vh - 250px)",
    overflowY: "auto",
    overflowX: "hidden",
    scrollbarGutter: "stable both-edges",
    // Tall drop target below the header when the folder is empty or has few rows
    minHeight: "min(560px, calc(100vh - 290px))",
  },

  /** Visual hint when dragging files onto the folder list */
  dropTargetActive: {
    outline: "2px dashed rgba(0, 118, 255, 0.55)",
    outlineOffset: -2,
    backgroundColor: "rgba(0, 118, 255, 0.06)",
    transition: "background-color 0.15s ease",
  },

  blueText: {
    color: "#0076FF",
  },

  listItem: {
    display: "grid",
    gridTemplateColumns: "5fr 1.2fr 0.8fr 1fr 1.6fr 50px",
    alignItems: "center",
    padding: "0 8px",
    fontSize: "13px",
    height: "40px",
    boxSizing: "border-box",
    textAlign: "left",
    transition: "background-color 0.15s ease",
    "&:hover": {
      backgroundColor: "#f5f7fb",
    },
  },

  headerCell: {
    display: "flex",
    alignItems: "center",
  },

  sortableHeader: {
    "&:hover": {
      backgroundColor: "rgba(255, 255, 255, 0.1)",
    },
    transition: "background-color 0.2s ease",
  },

  listIcon: {
    width: 24,
    height: 24,
    marginRight: "8px",
  },

  listFileName: {
    color: "#000000",
    fontWeight: 500,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    cursor: "pointer",
  },
  fileNameContainer: {
    display: "flex",
    alignItems: "center",
    gap: 0,
  },
  backLink: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "#0076FF",
    fontSize: "14px",
    fontWeight: 500,
    textDecoration: "none",
    position: "relative",
    marginTop: "-40px !i",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  rowEven: { backgroundColor: "#ffffff" },
  rowOdd: { backgroundColor: "#f9f9f9" },
  PathActive: {
    fontWeight: 600,
    color: "#1a1a1a",
  },
}));
